// extracted by mini-css-extract-plugin
module.exports = {"root":"CompleteLink_root__2HjhL","rootSuccess":"CompleteLink_rootSuccess__2U0MN","rootFailure":"CompleteLink_rootFailure__2gHIF","isDisabled":"CompleteLink_isDisabled__1fwiz"};